export enum UserType {
  INTERNAL = 'INT',
  EXTERNAL = 'EXT'
}

export enum BranchCodeType {
  HEAD_OFFICE = '1'
}
